<template lang="pug">
    .checkout(v-if="!hasPurchased")
        loading(:active="loading" :is-full-page="false" :height="40" :width="40" color="#000")
        Matrix(:product="product" v-for="product in filteredProducts" :key="product.id")
        Pagination(
            v-if="pageInfo && pageInfo.lastPage > 1"
            :last-page="pageInfo.lastPage"
            :current-page="pageInfo.currentPage"
            nav-class="pagination is-small is-rounded is-centered"
            @change="changePage"
            nextLinkClass="is-rounded pagination-next is-circle is-right"
            prevLinkClass="is-rounded pagination-previous is-circle is-left"
        )
            span.icon(slot="prev")
                i.fas.fa-arrow-left
            span.icon(slot="next")
                i.fas.fa-arrow-right
        .row.sub-total-row(v-if="filteredProducts && filteredProducts.length")
            .sub-total
                table.table.is-bordered
                    th.is-center.is-fixed-size.qty total qty
                    th.is-center.is-fixed-size(v-if="!taxFree") sub sum
                    th.is-center.is-fixed-size(v-else) total sum
                    tr
                        td.is-center.is-fixed-size.qty {{ qty }}
                        td.is-center.is-fixed-size {{ price }}
                .isNotTaxFree(v-if="!taxFree")
                    table.table.is-bordered
                        tr
                            th.is-center.is-fixed-size.qty tax
                            td.is-center.is-fixed-size {{ taxPrice }}
                    table.table.is-bordered
                        tr
                            th.is-center.is-fixed-size.qty total
                            td.is-center.is-fixed-size {{ priceWithTax }}
            .wrapper
                .printarea
                    button.is-primary.button(title="print your order" @click="print()")
                        span.icon
                            i.fas.fa-print
                .checkout-area
                    validation-provider(name="terms" :rules="{ required: { allowFalse: false } }" v-slot="{ errors }")
                        .control
                            label.checkbox
                                input(
                                    type="checkbox"
                                    name="terms"
                                    v-model="terms"
                                    :class="{ 'is-danger': errors && errors.length }"
                                )
                                |  I have read and agreed to the terms of service
                        p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                        p.help.has-text-grey(v-else) Required
                    button.button.is-primary(@click="placePreorder" :disabled="terms == false") place preoder now
        article.message(v-else-if="!loading")
            .message-body No items in shopping cart
    .checkout(v-else-if="hasPurchased")
        span(v-html="confirmationText")
        button.button.is-primary.confirm(@click="continueShopping") continue shopping
</template>
<script>
//import Components
import Matrix from './Partials/Matrix'
import Pagination from '@/components/Pagination'

import { mapGetters, mapActions } from 'vuex'
import { get, cloneDeep, removeDeepByKey, set, each, find, filter, round } from 'lodash'
import { moneyFormat, findPrice } from '@/filters'
import { ValidationProvider } from 'vee-validate'

import Loading from 'vue-loading-overlay'

export default {
    name: "Checkout",
    components: {
        Matrix,
        ValidationProvider,
        Loading,
        Pagination
    },
    data() {
        return {
            terms: false,
            hasPurchased: false,
            confirmationText: ' <b>thank you very much for your preorder.</b><br><br>your preorder is binding. changes and cancellations are possible within the next 10 days.<br>we will check your preorder at short notice and send an order confirmation or prepayment invoice without being asked, according to our terms of payment.<br>for further questions please use our hotline: +49 (0) 28 36 / 91 98 40  or our mail: b2b@studiorundholz.de<br><br>best regards<br><br>customer service team<br><br>studio rundholz gmbh',
            products: {
                items: []
            },
            perPage: 5,
            loading: false
        }
    },
    computed: {
        pageInfo() {
            return _.get(this.products, 'pageInfo')
        },
        taxFree() {
            return get(this.customer, 'tax_free')
        },
        taxPrice() {
            return this.formatPrice(get(this.cart, 'tax'))
        },
        articles() {
            return get(this.cart, 'articles', [])
        },
        priceWithTax() {
            return this.formatPrice(get(this.cart, 'sum'))
        },
        filteredProducts() {
            let products = cloneDeep(this.products.items)
            let articleIds = []
            const articles = this.articles
            articles.forEach(article => {
                articleIds.push(article.id)
            })
            products.forEach(product => {
                product.articles = filter(product.articles, article => {
                    if(articleIds.includes(article.id)) return article
                })
                // let qty = 0
                product.articles.forEach(productArticle => {
                    let article = find(articles, {'id': productArticle.id})
                    productArticle.qty = article.qty
                    // qty += article.qty
                })
                // product.qty_sum = qty
                product.price = findPrice(product, this.customer, this.defaultCustomerGroup, true)

                // const taxRate = _.get(price, 'tax.value') || this.defaultTax.value;
                // const tax = _.round((price.value * taxRate) / (100 + taxRate), 2);

                // const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'
                // product.priceWithTax = price.value * product.qty_sum
                // product.price = (price.value) * product.qty_sum

            })
            return products
        },
        qty() {
            return get(this.cart, 'qty')
        },
        price() {
            const sum = round(get(this.cart, 'sum'), 2)
            const tax = round(get(this.cart, 'tax'), 2)
            return this.formatPrice(sum - tax)
        },
        ...mapGetters({
            customer: 'shop/customer',
            member: 'auth/member',
            cms: 'CMS',
            defaultCustomerGroup: 'defaultCustomerGroup',
            cart: 'shop/cart',
            token: 'auth/token',
            defaultTax: 'defaultTax'
        }),
    },
    methods: {
        formatPrice(price) {
            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'
            return moneyFormat(price, code)
        },
        placePreorder() {
            if (this.cart.articles && this.cart.articles.length) {

                this.loading = true


                let items = []
                each(this.cart.articles, article => {
                    const item = {
                        qty: article.qty,
                        article: {
                            id: article.id
                        }
                    }
                    if (!find(items, item)) {
                        items.push(item)
                    }
                })

                const data = {
                    shop: {
                        id: this.cms.shop.id
                    },
                    purchaser: {
                        customer: {
                            id: this.customer.id,
                            member: {
                                id: this.member.id
                            }
                        }
                    },
                    items,
                    paymentMethod: {
                        id: get(this.cms, 'shop.paymentMethods[0].id')
                    }
                }
                this.createPurchase(data)
                    .then(() => {
                        const container = document.querySelector('.checkout-page-columns > .column.left > .ps')
                        if (container) container.scrollTop = 0

                        this.hasPurchased = true
                    })
                    .finally(() => this.loading = false)
            }
        },
        print() {
            window.print()
        },
        continueShopping() {
            this.hasPurchased = !this.hasPurchased
            this.products = {
                items: []
            }
        },
        changePage(currentPage) {
            this.refetch(currentPage)
        },
        refetch(currentPage = 1) {
            const shop = this.cms.shop.id
            const articleIds = this.articles.map(article => article.id)

            const payload = {
                pageInfo: {
                    currentPage,
                    perPage: this.perPage,
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'articles',
                        in: articleIds
                    }
                ],
            }

            if (articleIds && articleIds.length) {
                this.loading = true
                this.fetchProducts(payload)
                    .then(products => {
                        const el = document.querySelector('.section.checkout')
                        const container = document.querySelector('.checkout-page-columns > .column.left > .ps')
                        if (container) {
                            if (! el) container.scrollTop = 0
                            else el.scrollIntoView()
                        }

                        this.products = products
                    })
                    .finally(() => this.loading = false)
            }
        },
        ...mapActions({
            createPurchase: 'shop/createPurchase',
            fetchProducts: 'shop/fetchProductsWithArticlesPaginated',
        }),
    },
    mounted() {
        this.refetch()
    }
}
</script>
<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins";
    .checkout
        position: relative
        min-height: 200px
    button
        width: 100%
    table
        td
            font-weight: bold
            text-align: center
        th
            text-align: center
            background-color: #fafafa
    .confirm
        margin-top: 25px
    .is-fixed-size
        width: 125px
        font-weight: bold
    .is-fixed-size.qty
        width: 75px
    .is-borderless
        border: none
    .isNotTaxFree
        margin-bottom: 1.5rem
    .sub-total-row
        margin-top: 50px
    .row
        display: flex
        flex-direction: column
        justify-content: space-between
        .sub-total
            display: flex
            flex-direction: column
            align-items: flex-end
            margin-bottom: 25px
            table.table
                width: auto

        .wrapper
            display: flex
            flex-direction: row
            justify-content: space-between
            +mobile
                flex-direction: column
                height: 150px
            .checkout-area
                display: flex
                flex-direction: row
                justify-content: space-between
                width: 75%
                +mobile
                    flex-direction: column
                    width: 100%
                .control
                    padding-right: 25px
                button
                    width: 200px
                    +mobile
                        width: 100%
</style>
